export const isRichText = (richText)=>{
    return Boolean(richText?.content?.length);
};

//# sourceMappingURL=isRichtext.js.map